document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-video-showcase]').forEach(function (root) {
    var track = root.querySelector('[data-vs-track]');
    var prevBtn = root.querySelector('[data-vs-prev]');
    var nextBtn = root.querySelector('[data-vs-next]');
    var modal = root.querySelector('[data-vs-modal]');
    var modalMedia = root.querySelector('[data-vs-modal-media]');
    var closeBtns = root.querySelectorAll('[data-vs-close]');

    function scrollByAmount(dir) {
      var item = track.querySelector('[data-vs-item]');
      var step = item ? item.getBoundingClientRect().width + 12 : 200;
      track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });

    function openModal(type, src) {
      modalMedia.innerHTML = '';

      if (type === 'file') {
        var video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        modalMedia.appendChild(video);
      } else {
        var embedSrc = toEmbedUrl(src);
        if (embedSrc) {
          var iframe = document.createElement('iframe');
          iframe.src = embedSrc;
          iframe.allow = 'autoplay; fullscreen; encrypted-media';
          iframe.allowFullscreen = true;
          modalMedia.appendChild(iframe);
        } else {
          var vid2 = document.createElement('video');
          vid2.src = src;
          vid2.controls = true;
          vid2.autoplay = true;
          vid2.playsInline = true;
          modalMedia.appendChild(vid2);
        }
      }

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function toEmbedUrl(url) {
      if (!url) return null;
      var yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]+)/);
      if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&playsinline=1';
      var vm = url.match(/vimeo\.com\/(\d+)/);
      if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
      return null;
    }

    function closeModal() {
      modal.hidden = true;
      modalMedia.innerHTML = '';
      document.body.style.overflow = '';
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    track.querySelectorAll('[data-vs-item]').forEach(function (item) {
      item.addEventListener('click', function () {
        var type = item.getAttribute('data-video-type');
        var src = item.getAttribute('data-video-src');
        if (src) openModal(type, src);
      });
    });
  });
});